// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"dbf872d8","156":"097d0179","341":"d04918e4","438":"39bbd81a","706":"9961c39f","726":"3fe2ff88"}[chunkId] + ".chunk.js";
};